// Full-document render of the unified sales-channel order-status page (step 2):
// the breadcrumbs, an order-summary tracker island per returned order, and the
// customer-service info block. The track_order_lookup GA4 event(s) the legacy
// trackers_body block fired are pushed to the dataLayer after hydration.
import React from "react";
import { DataLayerPush } from "tsi-common-react/src/components/DataLayerPush/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { Template as CustomerServiceInfoBlock } from "./CustomerServiceInfoBlockTemplate";
import { Template as TrackOrderSummary } from "./TrackOrderSummaryTemplate";

export const Template = (
    props: templates.UnifiedOrderStatusDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width">
                <section>
                    <div>
                        <nav className="unified-order-breadcrumbs">
                            {props.crumbs.map((crumb, i) => (
                                <React.Fragment key={i}>
                                    {i > 0 && " / "}
                                    {crumb.href ? (
                                        <a href={crumb.href}>{crumb.label}</a>
                                    ) : (
                                        <span>{crumb.label}</span>
                                    )}
                                </React.Fragment>
                            ))}
                        </nav>
                        <h2>{props.heading}</h2>
                        <div>
                            {props.order_summaries.map((summary, i) => (
                                <TrackOrderSummary key={i} {...summary} />
                            ))}
                        </div>
                    </div>
                </section>
                <CustomerServiceInfoBlock {...props.cs_block} />
            </div>
            <DataLayerPush events={props.ga_events} />
        </PageSkeleton>
    );
};
